import { IAugmentedJQuery, IDirective, IDirectiveFactory, IScope, ITimeoutService } from "angular";

export const handleOutsideMouseEvent = (
  event: "click" | "mousedown" | "mouseup",
  callback: () => unknown,
  ...containers: (string | IAugmentedJQuery)[]
): (() => void) => {
  const eventHandler = (evt: JQueryEventObject) => {
    const possibleParents = containers.map((e) => (typeof e === "string" ? document.querySelector<HTMLElement>(e) : e[0])).filter((e) => !!e);
    for (const possibleParent of possibleParents) {
      if (possibleParent.contains(evt.target)) {
        return;
      }
    }

    callback();
  };

  document.body.addEventListener(event, eventHandler);
  return () => document.body.removeEventListener(event, eventHandler);
};

export const handleInsideMouseEvent = (event: "click" | "mousedown" | "mouseup", callback: () => unknown, ...containers: (string | IAugmentedJQuery)[]): (() => void) => {
  const eventHandler = (evt: JQueryEventObject) => {
    const possibleParents = containers.map((e) => (typeof e === "string" ? document.querySelector<HTMLElement>(e) : e[0])).filter((e) => !!e);
    for (const possibleParent of possibleParents) {
      if (possibleParent.contains(evt.target)) {
        callback();
        return;
      }
    }
  };

  document.body.addEventListener(event, eventHandler);
  return () => document.body.removeEventListener(event, eventHandler);
};

interface ICloseOnMousedownScope extends IScope {
  toggled: { [key: string]: boolean };
  changeState(): void;
  toggledProperty: string;
  excludedParentNodeSelectorList: string[];
}

export class CloseOnMousedown implements IDirective {
  public scope = {
    toggled: "=",
    changeState: "&",
    toggledProperty: "@",
    excludedParentNodeSelectorList: "<",
  };

  constructor(private $timeout: ITimeoutService) {}

  public link(scope: ICloseOnMousedownScope, element: IAugmentedJQuery): void {
    const handler = (evt: JQueryEventObject) => {
      if (scope.toggled[scope.toggledProperty]) {
        this.changeState(scope, element, evt);
      }
    };

    document.body.addEventListener("mousedown", handler);
    scope.$on("$destroy", () => document.body.removeEventListener("mousedown", handler));
  }

  private changeState = (scope: ICloseOnMousedownScope, element: IAugmentedJQuery, $event: JQueryEventObject) => {
    const excludedNodeList = (scope.excludedParentNodeSelectorList || []).reduce(
      (nodeList, selector) => [...nodeList, ...Array.from(document.querySelectorAll(selector))],
      [element[0]]
    );

    const isExcluded = excludedNodeList.some((node) => node.contains($event.target));
    if (!isExcluded) {
      scope.changeState();

      this.$timeout(() => (scope.toggled[scope.toggledProperty] = false));
    }
  };

  public static factory(): IDirectiveFactory {
    const directive = ($timeout: ITimeoutService) => new CloseOnMousedown($timeout);
    directive.$inject = ["$timeout"];
    return directive;
  }
}
